import { styled } from '@mui/material'
import { Box } from '@mui/material';

export const FollowUpStatusChip = styled(Box)({
  color: 'white',
  padding: '0px 8px',
  borderRadius: '6px',
  backgroundColor: 'rgba(173, 173, 173, 1)',
  height: '20px',
  alignItems: 'center',
  display: 'flex'
});
